import { LitEntity, html, css, renderIf } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-placeholder';
import './user-metric';

class UserStatistics extends LitEntity {
  static get styles() {
    return [sharedStyles, css`
      .header {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
      }

      .external-link {
        margin-left: 0.5em;
      }
    `];
  }

  render() {
    if (this.loading) {
      return html`
        <bn-loading></bn-loading>
      `;
    }

    const metricHrefs = this.entity?.getSubEntities('https://api.binsentry.com/rel/metric').map((entity) => entity.href);
    const posthogHref = this.getHref('https://api.binsentry.com/rel/posthog-person');

    return html`
      <div class="header">
        <h3>Statistics</h3>
        ${renderIf(posthogHref, () => html`
          <div>
            view in
            <a href="${posthogHref}" target="_blank">
              PostHog<bn-icon class="external-link" name="far fa-external-link"></bn-icon>
            </a>
          </div>
        `)}
      </div>
      <div class="properties">
        ${metricHrefs?.map((href) => html`
          <user-metric .href="${href}"></user-metric>
        `)}
      </div>
    `;
  }
}

window.customElements.define('user-statistics', UserStatistics);
